$(function () {
  svg4everybody();
  
  // switch
  $('.js-switch').on('click', function(){
    $('.js-switch__link').removeClass('active');
    if($(this).hasClass('on')){
      $(this).removeClass('on');
      $('.js-formula-symbol').removeClass('on');
      $('.js-switch__link').first().addClass('active');
    } else {
      $(this).addClass('on');
      $('.js-formula-symbol').addClass('on');
      $('.js-switch__link').last().addClass('active');
    }
  });
  $('.js-switch__link').on('click', function(){
    $('.js-switch__link').removeClass('active');
    $(this).addClass('active');
    if($(this).is(':last-child')){
      $('.js-switch, .js-formula-symbol').addClass('on');
    } else {
      $('.js-switch, .js-formula-symbol').removeClass('on');
    }
  });

  // tabs
  $('.js-tabs-title a').click(function(event){
    event.preventDefault();
    var closest = $(this).closest('.js-tabs');
    var el = $(this).attr('href');
    closest.find('.js-tabs-title a').removeClass('active');
    $(this).addClass('active');
    closest.find('.js-tab').removeClass('active');
    $(el).addClass('active');
    return false; 
  });

  // clear all
  $('.js-clear-all').on('click', function(){
    $(this).closest('.calc').find('.calc__input').val('');
    $(this).closest('.calc').find('.time-card__input').val('');
    $(this).closest('.calc').find('.js-hourly').val('');
    $('.js-total-pay').removeClass('active');
    
    var text = $(this).closest('.calc').find('.js-select .jq-selectbox__dropdown li').eq(0).text();
    $(this).closest('.calc').find('.js-select').val(text).trigger('refresh');
    $(this).closest('.calc').find('.jq-selectbox__trigger').append('<svg class="icon icon-down-arrow"><use xlink:href="img/spritesvg.svg#down-arrow"></use></svg>');
  });

  // ampm
  $('.js-time-card-ampm').on('click', function(){
    $(this).text() === 'AM' ? $(this).text('PM') : $(this).text('AM');
  });

  // input focus
  $('.time-card__input').on('focus', function(){
    $(this).parent().addClass('focus');
  });
  $('.time-card__input').on('blur', function(){
    $(this).parent().removeClass('focus');
  });

  // hourly
  $('.js-hourly').on('change', function(){
    $(this).val().length > 0 ? $('.js-total-pay').addClass('active') : $('.js-total-pay').removeClass('active');
  });

  // setting
  $('.js-setting-link').on('click', function(){
    $('.js-setting-hidden').slideToggle();
  }); 

  // calc input percentage
  $('.calc__input--percentage').on('change', function(){
    if($(this).val().length > 0){
      $(this).addClass('active');
    } else {
      $(this).removeClass('active');
    }
  });

  // increase
  $('.js-increase').on('click', function(){
    $(this).text() === 'INCREASE' ? $(this).text('Decrease') : $(this).text('INCREASE');
  });

  // time-zone-ampm
  $('.js-time-zone-ampm').on('click', function(){
    if($(this).hasClass('active')){
      $(this).removeClass('active').text('24');
      $(this).closest('.time-zone').find('.time-zone__ampm-label').removeClass('active');
    } else {
      $(this).addClass('active').text('12');
      $(this).closest('.time-zone').find('.time-zone__ampm-label').addClass('active');
    }
  });

  // weekend/holydey
  $('.js-setting-week').on('click', function(){
    var closest = $(this).closest('.setting__radio-wrap');
    var week = closest.find('.js-hidden-include-week');
    closest.find('.setting__radio input').trigger('click').trigger('refresh');
    if(week.hasClass('open')){
      week.removeClass('open');  
    } else {
      closest.find('.js-hidden-include-holy').removeClass('open');
      week.addClass('open');
    }
  });
  $('.js-setting-holy').on('click', function(){
    var closest = $(this).closest('.setting__radio-wrap');
    var holy = closest.find('.js-hidden-include-holy');
    closest.find('.setting__radio input').trigger('click').trigger('refresh');
    if(holy.hasClass('open')){
      holy.removeClass('open');  
    } else {
      closest.find('.js-hidden-include-week').removeClass('open');
      holy.addClass('open');
    }
  });

  // add-more
  $('.js-add-more').on('click', function(){
    var wrap = $(this).closest('.js-new-day-wrap');
    wrap.find('.js-new-day').clone().removeClass('js-new-day new-day__top--tpl').insertBefore(wrap.find('.new-day__buttons'));
    var closest = wrap.find('.new-day__top:nth-last-child(2)');
    closest.find('select').styler({
      selectSmartPositioning: false,
      onFormStyled: function(){
        closest.find('.jq-selectbox__trigger').append('<svg class="icon icon-down-arrow"><use xlink:href="img/spritesvg.svg#down-arrow"></use></svg>');
        
      },
      onSelectOpened: function(){
        $(this).find('.jq-selectbox__dropdown ul').scrollbar();
      },
    });
  });

  // gamb
  $('.js-gamb').click(function(){
    $(this).toggleClass('open');
    $('.js-gamb-hidden').toggleClass('open');
    if($(this).hasClass('open')){
      hideScroll();
    } else {
      showScroll();
    }
  });

  // клик в свободной зоне
  $(document).on('click touchstart', function(event){
    if($('.js-gamb').hasClass('open')){
      if( $(event.target).closest(".js-gamb-hidden").length || $(event.target).closest(".js-gamb").length )
        return;    
      $('.js-gamb').removeClass('open');
      $('.js-gamb-hidden').removeClass('open');
      showScroll();
    }
    event.stopPropagation();
  });

  $('.js-gamb-hidden .menu-header__link--dropdown').on('click', function(e){
    e.preventDefault();
    $(this).next('.dropdown-menu').slideToggle();
  });
  $('.js-gamb-hidden .lang-header__title').on('click', function(e){
    e.preventDefault();
    $(this).next('.lang-header__dropdown').slideToggle();
  });

  // select and inputs styled
  $('input:not([name="rating"])').styler();
  $('.js-select').styler({
    selectSmartPositioning: false,
    onFormStyled: function(){
      $('.js-select .jq-selectbox__trigger').append('<svg class="icon icon-down-arrow"><use xlink:href="img/spritesvg.svg#down-arrow"></use></svg>');
    },
    onSelectOpened: function(){
      $(this).find('.jq-selectbox__dropdown ul').scrollbar();
    },
  });

  // select chosen city
  $('.js-city-select').on('chosen:ready', function(evt, params) {
    $(this).closest('.time-zone__group').find('.chosen-single b').append('<svg class="icon icon-down-arrow"><use xlink:href="img/spritesvg.svg#down-arrow"></use></svg>');
    var date = $(this).find('option:selected').data('text');
    var text = $(this).find('option:selected').text();
    var newText = text.split(date).join("<i>"+date+"</i>");
    $(this).next('.chosen-container').find('.chosen-single span').html(newText);
  });
  $('.js-city-select').on('chosen:showing_dropdown', function(evt, params) {
    $(this).closest('.time-zone__group').find('.chosen-results').scrollbar();
    var $this = $(this);
    $('.time-zone .chosen-results li').each(function(){
      var index = $(this).data('option-array-index');
      var date = $this.find('option').eq(index).data('text');
      var text = $(this).text();
      var newText = text.split(date).join("<i>"+date+"</i>");
      $(this).html(newText);
      $('.chosen-search-input').attr('readonly', false);
    });

  });
  $('.js-city-select').on('chosen:hiding_dropdown', function(evt, params) {
    var curentText = $(this).next('.chosen-container').find('.chosen-single span').text();
    var index = $(this).find('option:contains("'+curentText+'")').index();
    var date = $(this).find('option').eq(index).data('text');
    var text = $(this).find('option').eq(index).text();
    var newText = text.split(date).join("<i>"+date+"</i>");
    $(this).next('.chosen-container').find('.chosen-single span').html(newText);
    $(this).next('.chosen-container').addClass('chosen-selected');
    $('.chosen-search-input').attr('readonly', true);
  });
  $('.js-city-select').chosen({
    inherit_select_classes: true,
  });

  // time zone remove
  $('.js-time-zone-remove').on('click', function(){
    $(this).closest('.time-zone').slideUp(400, function(){
      $(this).remove();
    });
  });

  $('.time-zone__input').on('focus', function() {
    $(this).select();
  });

  // scroll styled
  $('.js-scroll').scrollbar();
  
  // datepicker
  $('.js-calendar-link').on('click', function(){
    $(this).toggleClass('open').next('.js-calendar-hidden').toggleClass('open');
  });
  // клик в свободной зоне
  $(document).on('click touchstart', function(event){
    if($('.js-calendar-link').hasClass('open')){
      if( $(event.target).closest(".js-calendar-link").length || 
          $(event.target).closest(".js-calendar-hidden").length  || 
          $(event.target).closest(".datepicker--nav-title").length  || 
          $(event.target).closest('.datepicker--nav-action').length )
        return;    
      $('.js-calendar-link').removeClass('open');
      $('.js-calendar-hidden').removeClass('open');
      event.stopPropagation();
    }
  });

  $('.js-datepicker').datepicker({
    language: 'en',
    inline: true,
    toggleSelected: false,
    todayButton: new Date(),
    onSelect: function(formattedDate, date, inst){
      var monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var currentDate = date.getDate();
      var currentMonth = monthsShort[date.getMonth()];
      var currentYear = date.getFullYear();
      var closest = $(inst.el).closest('.calc__calendar');
      closest.find('.date-calendar__month').text(currentMonth);
      closest.find('.js-select').val(currentMonth).trigger('refresh');
      closest.find('.jq-selectbox__trigger').append('<svg class="icon icon-down-arrow"><use xlink:href="img/spritesvg.svg#down-arrow"></use></svg>');
      closest.find('.date-calendar__day').text(currentDate);
      closest.find('.calc__input--date').val(currentDate);
      closest.find('.date-calendar__year').text(currentYear);
      closest.find('.calc__input--year').val(currentYear);
    }
  });
});

;(function ($) { $.fn.datepicker.language['en'] = {
  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  months: ['January','February','March','April','May','June', 'July','August','September','October','November','December'],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  today: 'Today',
  clear: 'Clear',
  dateFormat: 'mm/dd/yyyy',
  timeFormat: 'hh:ii aa',
  firstDay: 0
}; })(jQuery);

// дополние к стилизации селектов
// проверка на яблоки
function IOS() {
  return navigator.userAgent.match(/iPhone|iPad|iPod/i);
}
// проверка на тач устроства
function is_touch_device() {
  return !!('ontouchstart' in window);
}
if (IOS()) {
  $('body').addClass('body-ios');

  $('.js-select').change(function(){
    setTimeout(function() {
      $('select').trigger('refresh');
    }, 1);
  });

  $('.jq-selectbox').on('touchstart', function(){
    if ($(this).hasClass('opened')) {
      $(this).removeClass('changed focused dropdown opened').css({'z-index':'0'}).find('.jq-selectbox__dropdown').fadeOut(0);  
    } else {
      $('.jq-selectbox').removeClass('changed focused dropdown opened').css({'z-index':'0'}).find('.jq-selectbox__dropdown').fadeOut(0); 
      $(this).addClass('focused dropdown opened').css({'z-index':'100'}).find('.jq-selectbox__dropdown').fadeIn(0);
    }
  }); 
  $('.jq-selectbox li').on('touchstart', function(){
    $(this).closest('.jq-selectbox').removeClass('changed focused dropdown opened').css({'z-index':'0'}).find('.jq-selectbox__dropdown').fadeOut(0);
  });
} 

// fix scroll
function hideScroll() {
  var _this = document;
  _this.body.classList.add('no-scroll');

  _this.scrollTop = window.pageYOffset; // запоминаем текущую прокрутку сверху
  _this.body.style.position = 'fixed';
  if (hasScrollbar()) {
  // с учетом горизонтального скролла. Чтобы небыло рывка при открытии модального окна
      _this.body.style.width = 'calc(100% - ${getScrollbarSize()}px)';
  } else {
      _this.body.style.width = '100%';
  }
  _this.body.style.top = -_this.scrollTop + 'px';
}
function getScrollbarSize() { // получение ширины скролла
  var outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

  document.body.appendChild(outer);

  var widthNoScroll = outer.offsetWidth;
  // force scrollbars
  outer.style.overflow = 'scroll';

  // add innerdiv
  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  var widthWithScroll = inner.offsetWidth;

  // remove divs
  outer.parentNode.removeChild(outer);
  return widthNoScroll - widthWithScroll;
}
function hasScrollbar() { // проверка на боковой скролл
  return document.body.scrollHeight > document.body.clientHeight;
}
function showScroll() {
  var _this = document;
  _this.body.classList.remove('no-scroll');
  _this.body.style.position = '';
  _this.body.style.width = '';
  _this.body.style.top = '';
  window.scroll(0, _this.scrollTop);
}
